module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAABEUlEQVRYR+2YMVLCUBCG/z9wAuggSUUFpZUncCygksLa4QAmM9bcQ72ApNLCsUhS2kAn3kA6OYFkmTBCxczShLxiX/vv2/3f97bYWYZROgV5A2CAes8SIgnDOPsB0KnXy6H6ikGUPZG4c8GQCJ7p3+c9zyuuIWjXaor4LQrvnbWaOFLcDGk/YoSMkEZA062HjJBGQNPd66EgykYgrgD0NfcV698QfJTz0BzARcXFTk2/YBjnL4CMT71RbRxnDOL0FtiNsK1qi6nZ14Ak7jW16vvMAUZIA26EjJBGQNOth4yQRkDT2X3I/cZfcenCfmjT9D7L8eMVkKHm/Dw638oB7csBOvv3Lvm/0ps4sEVbQeRxC7saOTOfljw1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/hhdimg/nav/4.png
// module id = TVi3
// module chunks = 19